import React from "react";
import AssetListContainer from "../../components/assets/AssetListContainer";
import "../../components/assets/assets.css";

const Assets = () => {
  return (
    <div className="assets-component-page component-page">
      <AssetListContainer />
    </div>
  );
};

export default Assets;
